import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import BrandLogo from "./BrandLogo";

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const isHome = location.pathname === "/";

  const close = () => setOpen(false);

  return (
    <nav className={`navbar${isHome ? " navbar-home" : ""}`}>
      <div className="navbar-top">
        <BrandLogo variant="horizontal" light={isHome} />

        <button
          type="button"
          className="navbar-toggle"
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "×" : "☰"}
        </button>
      </div>

      <div className={`navbar-links${open ? " open" : ""}`}>
        <Link to="/#how-it-works" className="nav-link" onClick={close}>
          How It Works
        </Link>
        <Link to="/weddings/public" className="nav-link" onClick={close}>
          Discover
        </Link>

        {user ? (
          <>
            <Link to="/my-weddings" className="nav-link" onClick={close}>
              My Weddings
            </Link>
            <Link to="/profile" className="nav-link" onClick={close}>
              Profile
            </Link>
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={() => {
                close();
                logout();
              }}
            >
              Sign Out
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="nav-link" onClick={close}>
              Log In
            </Link>
            <Link to="/signup" className="btn btn-primary btn-sm" onClick={close}>
              Get Started
            </Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
